export default __webpack_public_path__ + "static/media/transparent.d932cc9d.svg";